import { AUDIO_UPLOAD } from '@/shared/constants';

/** Clé i18n de l'erreur d'un fichier audio refusé (format ou taille), sinon null. */
export function getAudioFileErrorKey(file: File): 'format' | 'size' | null {
  const extension = file.name.split('.').pop()?.toLowerCase();
  if (extension !== 'mp3') return 'format';
  if (file.size > AUDIO_UPLOAD.MAX_SIZE_BYTES) return 'size';
  return null;
}
